<app-page>
    <app-device-header [deviceId]="deviceId"></app-device-header>
    <div>
        <table>
            <tr>
                <td>
                    <app-action [text]="'capture_5_min_remote_logs' | translate" [defaultStyle]=true (onExecute)="capture5MinRemoteLogs()"></app-action>
                </td>
            </tr>
        </table>
    </div>
    <app-device-remote-logs [deviceId]="deviceId"></app-device-remote-logs>
</app-page>
